import React from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';

type LayoutProps = {
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <header className="header">
        <h1>Watanabe Portfolio</h1>
        <nav>
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/research">Research</Link>
          <Link to="/skills">Skills</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </header>

      <main className="main-content">{children}</main>

      <footer className="footer">
        <small>© 2025 Watanabe. All rights reserved.</small>
      </footer>
    </div>
  );
};

export default Layout;
